// retrospectiveTemplates.ts
export interface ColumnConfig {
  id: string;
  title: string;
  subtitle: string;
  color: string;
  childColor: string;
  x: number;
  y: number;
  width: number;
  height: number;
  placeholderText: string;
  showStickyPad?: boolean;
}

export interface TemplateConfig {
  templateId: string;
  templateName: string;
  columns: ColumnConfig[];
}

export const retrospectiveTemplates: Record<string, TemplateConfig> = {
  "start-stop-continue": {
    templateId: "start-stop-continue-v1",
    templateName: "Start-Stop-Continue",
    columns: [
      {
        id: "stop",
        title: "Stop",
        subtitle: "Things to stop doing",
        color: "#FFEBEE",
        childColor: "#FFCDD2",
        x: 40,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What should we stop doing?",
        showStickyPad: true,
      },
      {
        id: "start",
        title: "Start",
        subtitle: "Things to start doing",
        color: "#E3F2FD",
        childColor: "#BBDEFB",
        x: 380,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What should we start doing?",
        showStickyPad: true,
      },
      {
        id: "continue",
        title: "Continue",
        subtitle: "Things to continue doing",
        color: "#E8F5E8",
        childColor: "#C8E6C9",
        x: 720,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What should we continue doing?",
        showStickyPad: true,
      },
      {
        id: "discussion",
        title: "Discussion and action items",
        subtitle: "Discussion and action items",
        color: "#F3E5F5",
        childColor: "#E1BEE7",
        x: 1060,
        y: 80,
        width: 400,
        height: 650,
        placeholderText: "Action items or topics...",
        showStickyPad: false,
      },
    ],
  },
  "mad-sad-glad": {
    templateId: "mad-sad-glad-v1",
    templateName: "Mad-Sad-Glad",
    columns: [
      {
        id: "mad",
        title: "Mad",
        subtitle: "What made us mad?",
        color: "#FFF9C4",
        childColor: "#FFF59D",
        x: 40,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What made us mad?",
        showStickyPad: true,
      },
      {
        id: "sad",
        title: "Sad",
        subtitle: "What made us sad?",
        color: "#FFEBEE",
        childColor: "#FFCDD2",
        x: 380,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What made us sad?",
        showStickyPad: true,
      },
      {
        id: "glad",
        title: "Glad",
        subtitle: "What made us glad?",
        color: "#E8F5E8",
        childColor: "#C8E6C9",
        x: 720,
        y: 80,
        width: 320,
        height: 650,
        placeholderText: "What made us glad?",
        showStickyPad: true,
      },
      {
        id: "discussion",
        title: "Discussion and action items",
        subtitle: "Discussion and action items",
        color: "#F3E5F5",
        childColor: "#E1BEE7",
        x: 1060,
        y: 80,
        width: 400,
        height: 650,
        placeholderText: "Discussion and action items",
        showStickyPad: false,
      },
    ],
  },
};
